import removeAnswer from './removeanswer';

export default function addAnswer(element) {
    let dropdowns = document.querySelectorAll('.dropdowns');
    let activeDropdown;

    for(let i = 0; i < dropdowns.length; i++) {

        if (dropdowns[i].style.display == 'block') {

            activeDropdown = dropdowns[i];
            break;

        }

    }
    
    // now get last radio input in this element to check his data-order value
    let temp            = activeDropdown.getElementsByTagName('input');
    let lastRadioOption = temp[temp.length - 1];
    let orderNumber     = Number(lastRadioOption.dataset.order) + 1;
    var divID           = $(element).data('id');

    $('#' + divID).find('.addAnswer').parent().remove();

    if(unitType === window.global_vars.unit_types.test) {
        $('#' + divID).append('<div class="answerswrap">' +
            '<span class="error">' + window.trans.lms.EmptyRequiredField + '</span>' +
            '<div class="input-group">' +
            '<input type="text" name="' + divID + '[]" class="form-control" placeholder="option for selected dropdown">' +
            '<input type="hidden" name="' + divID + '_answer_keys[]" value="' + orderNumber + '">' +
            '<span class="input-group-addon" style="padding:0;"><a class="btn btn-link negative removeAnswer" data-id="' + divID + '">-</a></span>' +
            '<span class="input-group-addon" style="padding:0;"><a class="btn btn-primary positive addAnswer" data-id="' + divID + '"style="border-top-left-radius:0px!important;border-bottom-left-radius:0px!important; border-top-right-radius:5px!important;border-bottom-right-radius:5px!important;">+</a></span>' +
            '</div>' +
            '<label>' + window.trans.lms.CorrectAnswer + ' ' +
            '<input type="radio" class="radios" value="' + orderNumber + '" name="correct_' + divID + '" data-order="' + orderNumber + '">' +
            '</label>' +
            '</div>');
    } else if(unitType === window.global_vars.unit_types.feedback) {
        $('#' + divID).append('<div class="answerswrap">' +
            '<span class="error">' + window.trans.lms.EmptyRequiredField + '</span>' +
            '<div class="input-group">' +
            '<input type="text" name="' + divID + '[]" class="form-control" placeholder="option for selected dropdown">' +
            '<input type="hidden" name="' + divID + '_answer_keys[]" value="' + orderNumber + '">' +
            '<span class="input-group-addon" style="padding:0;"><a class="btn btn-link negative removeAnswer" data-id="' + divID + '">-</a></span>' +
            '<span class="input-group-addon" style="padding:0;"><a class="btn btn-primary positive addAnswer" data-id="' + divID + '"style="border-top-left-radius:0px!important;border-bottom-left-radius:0px!important; border-top-right-radius:5px!important;border-bottom-right-radius:5px!important;">+</a></span>' +
            '</div>' +
            '<input style="display:none" type="radio" class="radios" value="false" name="correct_' + divID + '" data-order="' + orderNumber + '">' +
            '</label>' +
            '</div>');
    }

    $('.addAnswer').off().on('click', function(){

        addAnswer(this);

    });

    $('.removeAnswer').off().on('click', function(){

        removeAnswer(this);

    });
    
}